import { memo } from 'react';
import { type PageCmsPanelRow, type PanelSize } from '../common/panel-types';
import { PanelRow } from '../CustomPage.styled';
import { PanelItem } from './PanelItem';

interface PanelGridRowProps {
  readonly row: PageCmsPanelRow;
  readonly rowIndex: number;
  readonly onSizeChange: (rowIndex: number, panelId: string, size: PanelSize) => void;
  readonly onDeletePanel: (rowIndex: number, panelId: string) => void;
}

const PanelGridRowComponent = ({ row, rowIndex, onSizeChange, onDeletePanel }: PanelGridRowProps) => (
  <PanelRow data-testid={`panel-grid-row-${rowIndex}`}>
    {row.map((panel) => (
      <PanelItem
        key={panel.id}
        panel={panel}
        panelCount={row.length}
        rowIndex={rowIndex}
        onSizeChange={onSizeChange}
        onDeletePanel={onDeletePanel}
      />
    ))}
  </PanelRow>
);

// Panel edits are immutable, so untouched rows keep their `row` reference and skip re-rendering.
export const PanelGridRow = memo(PanelGridRowComponent);
